import { faEdit } from '~components/icon';
import { Column } from '~components/table-view';
import { linkCellRender } from '~components/table-view/columnRenderers';
import CoContributionExportActions from '~support-at-home/components/co-contributions/CoContributionExportActions';

import StatusWithSourceCell from './StatusWithSourceCell';

export const columnsFactory = (openInvoiceModal: (id: string) => void): Column[] => [
  {
    id: 'reference',
    header: 'Reference',
    type: 'text',
    renderReadOnly: linkCellRender((row) => openInvoiceModal(String(row.id)), faEdit),
  },
  {
    id: 'client',
    header: 'Client Name',
    type: 'text',
    deriveValue: (row) => row.client?.full_name,
  },
  {
    id: 'invoice_date',
    header: 'Invoice Date',
    type: 'date',
  },
  {
    id: 'due_date',
    header: 'Due Date',
    type: 'date',
  },
  {
    id: 'total_amount',
    header: 'Total',
    type: 'currency',
  },
  {
    id: 'status',
    header: 'Status',
    type: 'custom',
    component: StatusWithSourceCell,
  },
  {
    id: 'export_actions',
    header: 'Actions',
    type: 'custom',
    component: CoContributionExportActions,
  },
];
